/* Convierte el texto pegado desde Excel (tabulaciones) o un CSV (; o ,) en filas para importar.
   Sin librerías: copiar celdas de Excel y pegarlas ya llega separado por tabulaciones. */

const sinTildes = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

// Orden por defecto cuando no hay encabezados
export const ORDEN_DEFECTO = ['cedula', 'apellidos', 'nombres', 'puesto', 'fecha_ingreso'];

function campoDeEncabezado(h) {
  h = sinTildes(h);
  if (/(^|\s)(ced|ident|document)/.test(h) || h === 'ci') return 'cedula';
  if (h.startsWith('apell')) return 'apellidos';
  if (h.startsWith('nomb')) return 'nombres';
  if (/puesto|cargo|ocupa/.test(h)) return 'puesto';
  if (/sexo|genero/.test(h)) return 'sexo';
  if (/nac/.test(h)) return 'fecha_nacimiento';
  if (/ingreso|inicio|contrat/.test(h)) return 'fecha_ingreso';
  if (/mail|correo/.test(h)) return 'email';
  if (/tel|celu|movil/.test(h)) return 'telefono';
  return null;
}

function separarLinea(linea, sep) {
  if (sep === '\t') return linea.split('\t').map(x => x.trim());
  const out = []; let cur = ''; let q = false;
  for (let i = 0; i < linea.length; i++) {
    const c = linea[i];
    if (c === '"') { if (q && linea[i + 1] === '"') { cur += '"'; i++; } else q = !q; }
    else if (c === sep && !q) { out.push(cur.trim()); cur = ''; }
    else cur += c;
  }
  out.push(cur.trim());
  return out;
}

/** @returns {{filas: object[], columnas: string[], conEncabezado: boolean}} */
export function parsearNomina(texto) {
  const lineas = String(texto || '').replace(/^﻿/, '').split(/\r?\n/).filter(l => l.trim() !== '');
  if (!lineas.length) return { filas: [], columnas: [], conEncabezado: false };
  const muestra = lineas[0];
  const sep = muestra.includes('\t') ? '\t' : (muestra.split(';').length > muestra.split(',').length ? ';' : ',');
  const celdas = lineas.map(l => separarLinea(l, sep));

  const mapeo = celdas[0].map(campoDeEncabezado);
  const conEncabezado = mapeo.includes('cedula') || (mapeo.filter(Boolean).length >= 2);
  const columnas = conEncabezado ? mapeo : ORDEN_DEFECTO.slice(0, celdas[0].length);
  const datos = conEncabezado ? celdas.slice(1) : celdas;
  const filas = datos.map(c => {
    const f = {};
    columnas.forEach((campo, i) => { if (campo && c[i] !== undefined && c[i] !== '') f[campo] = c[i]; });
    return f;
  }).filter(f => Object.keys(f).length > 0);
  return { filas, columnas: columnas.filter(Boolean), conEncabezado };
}
